<template>
    <div>
        <div class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center profile-header"
             style="min-height: 200px;">
            <b-container fluid>
                <span class="mask bg-gradient-success opacity-8"></span>
            </b-container>
        </div>
        <b-container v-if="isLoading" fluid class="mt--7">
                <card v-if="isLoading">
                    Loading...
                </card>
        </b-container>
        <b-container v-else fluid class="mt--7">
        <div>
            <card>
                <b-row class="align-items-center">
                    <b-col>
                        <base-input label="ID" placeholder="ID" :readonly="true" v-model="report.id" />
                    </b-col>
                    <b-col>
                        <base-input label="Name" placeholder="Name" v-model="report.name" />
                    </b-col>
                    <b-col>
                        <base-input label="Search ID" placeholder="Search ID" v-model="report.search_id" />
                    </b-col>
                    <b-col>
                        <base-input label="Created at">
                        <p>{{report.created_at}}</p>
                        </base-input>
                    </b-col>
                    <b-col class="right-align-button">
                        <button class="btn btn-success" @click="saveLocationReport()">{{report.id===null ? 'Create' : 'Save'}}</button>
                    </b-col>
                </b-row>
            </card>
        </div>
        <div v-if="report.id!==null">
            <card>
                <div class="table-show-header">
                    <h4>Imported job histories (click to remove)</h4>
                    <base-button icon type="info" @click="showImportedLogs=!showImportedLogs">
                        <span class="btn-inner--icon">
                            <i :class="{'ni ni-fat-add':!showImportedLogs, 'ni ni-fat-delete':showImportedLogs}" />
                        </span>
                    </base-button>
                </div>
                <div v-if="showImportedLogs">
                    <div class="badge badge-primary d-inline-flex align-items-center mr-1" v-for="(v,k) in importedLogs" :key="k+'_importedlog'">
                        <router-link v-bind:key="k+'_importedlog_router'" :to="'/job_history/'+k">
                            {{k}} - {{v}}
                        </router-link>
                        <span class="closebtn" @click="setJobHistoryReportId(parseInt(k),null)">&times;</span>
                    </div>
                </div>
                <div class="table-show-header">
                    <h4>Job histories</h4>
                    <base-button icon type="info" @click="showJobHistories=!showJobHistories">
                        <span class="btn-inner--icon">
                            <i :class="{'ni ni-fat-add':!showJobHistories, 'ni ni-fat-delete':showJobHistories}" />
                        </span>
                    </base-button>
                </div>
                <div v-if="showJobHistories">
                    <base-input label="Name" placeholder="Name" v-model="jobHistoriesFilters.job__domain__name__icontains" />
                    <p v-if="jobHistoriesLoading">Loading...</p>
                    <div v-else>
                        <el-table class="table-responsive table"
                                  header-row-class-name="thead-light"
                                  :data="jobHistories">
                            <el-table-column label="ID" prop="id" />
                            <el-table-column label="Domain" prop="job.domain.name" />
                            <el-table-column label="End time" prop="end_time" />
                            <el-table-column label="Add to report data">
                                <template v-slot="{row}">
                                    <b-media no-body class="align-items-center">
                                        <button v-if="row.report_id===report.id" class="btn btn-success"  @click="setJobHistoryReportId(row.id,null)">
                                            <i class="ni ni-check-bold" />
                                        </button>
                                        <button v-else class="btn btn-info" @click="setJobHistoryReportId(row.id,report.id)">
                                            <i class="ni ni-fat-add" />
                                        </button>
                                    </b-media>
                                </template>
                            </el-table-column>
                        </el-table>

                        <b-card-footer class="py-4 d-flex justify-content-end">
                            <base-pagination v-model="jobHistoriesPage" :per-page="10" :total="jobHistoriesTotal" @change="jobHistoryPageChanged">
                                <template v-slot:prev-text>
                                    <a class="page-link" aria-label="Previous">
                                        <span aria-hidden="true"><i class="fa fa-angle-left" aria-hidden="true"></i></span>
                                    </a>
                                </template>
                            </base-pagination>
                        </b-card-footer>
                    </div>
                    
                </div>

                <div class="table-show-header">
                    <h4>Job group histories</h4>
                    <base-button icon type="info" @click="showJobGroupHistories=!showJobGroupHistories">
                        <span class="btn-inner--icon">
                            <i :class="{'ni ni-fat-add':!showJobGroupHistories, 'ni ni-fat-delete':showJobGroupHistories}" />
                        </span>
                    </base-button>
                </div>
                <div v-if="showJobGroupHistories">
                    <base-input label="Name" placeholder="Name" v-model="jobGroupHistoriesFilters.job_group__name__icontains" />
                    <p v-if="jobGroupHistoriesLoading">Loading...</p>
                    <div v-else>
                        <el-table class="table-responsive table"
                                  header-row-class-name="thead-light"
                                  :data="jobGroupHistories">
                            <el-table-column label="ID" prop="id" />
                            <el-table-column label="Job group name" prop="job_group" />
                            <el-table-column label="Start time" prop="start_time" />
                            <el-table-column label="Add to report data">
                                <template v-slot="{row}">
                                    <b-media no-body class="align-items-center">
                                        <base-button icon type="info" @click="setJobGroupHistoryReportId(row.id,report.id)">
                                            <span class="btn-inner--icon">
                                                <i class="ni ni-fat-add" />
                                            </span>
                                        </base-button>
                                    </b-media>
                                </template>
                            </el-table-column>
                            <el-table-column label="Remove from report data">
                                <template v-slot="{row}">
                                    <b-media no-body class="align-items-center">
                                        <base-button icom type="danger" @click="setJobGroupHistoryReportId(row.id,0)">
                                            <span class="btn-inner--icon">
                                                <i class="ni ni-fat-remove" />
                                            </span>
                                        </base-button>
                                    </b-media>
                                </template>
                            </el-table-column>
                        </el-table>

                        <b-card-footer class="py-4 d-flex justify-content-end">
                            <base-pagination v-model="jobGroupHistoriesPage" :per-page="10" :total="jobGroupHistoriesTotal" @change="jobGroupHistoryPageChanged">
                                <template v-slot:prev-text>
                                    <a class="page-link" aria-label="Previous">
                                        <span aria-hidden="true"><i class="fa fa-angle-left" aria-hidden="true"></i></span>
                                    </a>
                                </template>
                            </base-pagination>
                        </b-card-footer>
                    </div>
                    
                </div>

                <div class="table-show-header">
                    <h4>Manual imports</h4>
                    <base-button icon type="info" @click="showManualImports=!showManualImports">
                        <span class="btn-inner--icon">
                            <i :class="{'ni ni-fat-add':!showManualImports, 'ni ni-fat-delete':showManualImports}" />
                        </span>
                    </base-button>
                </div>
                <div v-if="showManualImports">
                    <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving">
                        <div class="dropbox">
                        <input type="file" multiple :name="uploadFieldName" :disabled="isSaving" 
                            @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
                            accept="text/csv" class="input-file">
                            <p v-if="isInitial">
                            Drag your file(s) here to begin<br> or click to browse
                            </p>
                            <p v-if="isSaving">
                            Uploading {{ fileCount }} files...
                            </p>
                        </div>
                    </form>
                    <!--SUCCESS-->
                    <div v-if="isSuccess">
                        <h2>Uploaded {{ fileCount }} file(s) successfully.</h2>
                        <p>
                        <a href="javascript:void(0)" @click="reset()">Upload again</a>
                        </p>
                    </div>
                    <!--FAILED-->
                    <div v-if="isFailed">
                        <h2>Upload failed.</h2>
                        <p>
                        <a href="javascript:void(0)" @click="reset()">Try again</a>
                        </p>
                        <pre>{{ uploadError }}</pre>
                    </div>
                </div>

                <div class="table-show-header">
                    <h4>Manual actions</h4>
                    <base-button icon type="info" @click="showReportActions=!showReportActions">
                        <span class="btn-inner--icon">
                            <i :class="{'ni ni-fat-add':!showReportActions, 'ni ni-fat-delete':showReportActions}" />
                        </span>
                    </base-button>
                </div>
                <div v-if="showReportActions">
                    <base-input label="Previous search ID" placeholder="Previous search ID" v-model="previousSearchId" />
                    <button class="btn btn-success" @click="runReportOperation(4,{'prev_search_id':previousSearchId})">Run all</button>
                    <button class="btn btn-success" @click="runReportOperation(0,{})">Geocode</button>
                    <button class="btn btn-success" @click="runReportOperation(1,{})">Geohash</button>
                    <button class="btn btn-success" @click="runReportOperation(2,{'prev_search_id':previousSearchId})">Site codes</button>
                    <button class="btn btn-success" @click="runReportOperation(3,{'prev_search_id':previousSearchId})">Get report</button>
                </div>
                <report-process-view ref="report_detail_page_process_view" />
            </card>
        </div>
        <card v-else>
            <h4>Create report to access report actions</h4>
        </card>
        </b-container>
    </div>
</template>

<script>
import {Table,TableColumn} from 'element-ui'
import ReportProcessView from './components/ReportProcessView.vue';

import RepositoryFactory from '@/repositories/RepositoryFactory'

const LocationReportRepository = RepositoryFactory.get('location_report');
const JobHistoryRepository = RepositoryFactory.get('job_history');
const JobGroupHistoryRepository = RepositoryFactory.get('job_group_log');

const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;

export default {
    props:{
        id:String,
    },
    components:{
        [Table.name]:Table,
        [TableColumn.name]:TableColumn,
        [ReportProcessView.name]:ReportProcessView,
    },
    data(){
        return {
            report:null,
            importedLogs:{},
            showImportedLogs:true,

            isLoading:true,

            jobHistories:null,
            jobHistoriesFilters:{status:'2'},
            showJobHistories:false,
            jobHistoriesLoading:true,
            jobHistoriesPage:1,
            jobHistoriesTotal:0,
            jobHistoriesLastRequestTimestamp:0, // Son atılan isteğin zamanı. İsteklerin birbirini ezmesi durumunun önüne geçmek için.

            jobGroupHistories:null,
            jobGroupHistoriesFilters:{},
            jobGroupHistoriesFilterTimer:undefined,
            showJobGroupHistories:false,
            jobGroupHistoriesLoading:true,
            jobGroupHistoriesPage:1,
            jobGroupHistoriesTotal:0,
            jobGroupHistoriesLastRequestTimestamp:0, // Son atılan isteğin zamanı. İsteklerin birbirini ezmesi durumunun önüne geçmek için.

            showManualImports:false,
            importFile:null,
            fileCount:0,
            
            uploadedFiles: [],
            uploadError: null,
            currentStatus: null,
            uploadFieldName: 'manual_imports',

            showReportActions:true,
            previousSearchId:null,
        }
    },
    watch:{
        jobHistoriesFilters:{
            handler(oldVal,newVal){
                clearTimeout(this.jobHistoriesFilterTimer);
                this.jobHistoriesLoading=true;
                for(var i in this.jobHistoriesFilters){
                    if(this.jobHistoriesFilters[i]==="")
                        delete this.jobHistoriesFilters[i]
                    }
                this.jobHistoriesFilterTimer=setTimeout(() => {
                    this.getJobHistories(1);

                }, 1000);
            },
            deep:true,
        },
        jobGroupHistoriesFilters:{
            handler(oldVal,newVal){
                clearTimeout(this.jobGroupHistoriesFilterTimer);
                this.jobGroupHistoriesLoading=true;
                for(var i in this.jobGroupHistoriesFilters){
                    if(this.jobGroupHistoriesFilters[i]==="")
                        delete this.jobGroupHistoriesFilters[i]
                    }
                this.jobGroupHistoriesFilterTimer=setTimeout(() => this.getJobGroupHistories(1), 1000);
            },
            deep:true,
        }
    },
    computed: {
      isInitial() {
        return this.currentStatus === STATUS_INITIAL;
      },
      isSaving() {
        return this.currentStatus === STATUS_SAVING;
      },
      isSuccess() {
        return this.currentStatus === STATUS_SUCCESS;
      },
      isFailed() {
        return this.currentStatus === STATUS_FAILED;
        
      }
    },
    created(){
        if(this.id==="new"){
            this.report={
                id:null,
                name:'',
                search_id:null,
                created_at:'Not created yet',
            }
            this.isLoading=false;
        }
        else{
            LocationReportRepository.getWithId(this.id).then((response) => {
                this.report=response.data[0]
                this.report.created_at=this.formatDefaultDate(this.timestampToDatetime(this.report.created_at));
                JobHistoryRepository.getWithReportId(this.report.id).then((response) => {
                    var data=response.data;
                    for(var i in data){
                        var d=data[i];
                        this.importedLogs[d.id]=d.job;
                    }
                    this.isLoading=false;
                })
            })
        }

        this.getJobHistories(this.jobHistoriesPage);
        this.getJobGroupHistories(this.jobGroupHistoriesPage);
    },
    methods:{
        saveLocationReport(){
            var reportData={
                name:this.report.name,
                search_id:this.report.search_id,
            }
            if(this.report.id===null){ // Yeni
                reportData.created_at=Math.ceil(this.datetimeToTimestamp(new Date()));
                LocationReportRepository.post(reportData).then((response) => {
                   
                    this.report=response.data;
                    this.report.created_at=this.formatDefaultDate(this.timestampToDatetime(this.report.created_at))
                    this.$router.push({name:'location report',params:{id:this.report.id}});
                    
                }).catch(this.$notify({
                        message: 'Location report not saved, search id already exists!',
                        type: 'danger',
                        size: 'lg',
                        timeout: 5000,
                        showClose: true,
                    })); 
            }
            else { // Update
                LocationReportRepository.put(this.report.id,reportData).then((response) => {
                    this.$notify({
                        message: 'Location report saved',
                        type: 'success',
                        size: 'lg',
                        timeout: 5000,
                        showClose: true,
                    })
                });
            }
        },
        getJobHistories(pageNumber){
            var timestamp=Date.now()
            this.jobHistoriesLastRequestTimestamp=timestamp;

            this.jobHistoriesLoading=true;
            this.jobHistoriesPage=pageNumber;
            
            JobHistoryRepository.getTable(pageNumber,this.jobHistoriesFilters).then((response) => {
                if(this.jobHistoriesLastRequestTimestamp!==timestamp) return; // Son atılan istek bu değil demek.

                var r=response.data;

                this.jobHistories=r.results;
                this.jobHistoriesTotal=r.count;
                this.jobHistoriesPage=pageNumber;

                for(var i in this.jobHistories){
                    if(this.jobHistories[i].job===null){
                        this.jobHistories[i].job={
                            domain:{
                                name:'Malformed data',
                                domain_address:'Malformed data',
                            }
                        }
                    }
                    if (this.jobHistories[i].start_time!==null && this.jobHistories[i].start_time!==undefined)
                        this.jobHistories[i].start_time=this.formatDefaultDate(this.timestampToDatetime(this.jobHistories[i].start_time));
                    
                    if (this.jobHistories[i].end_time!==null && this.jobHistories[i].end_time!==undefined)
                        this.jobHistories[i].end_time=this.formatDefaultDate(this.timestampToDatetime(this.jobHistories[i].end_time));
                }

                this.jobHistoriesLoading=false;
            })
        },
        jobHistoryPageChanged(pageNumber){
            this.getJobHistories(pageNumber);
        },
        getJobGroupHistories(pageNumber){
            var timestamp=Date.now()
            this.jobGroupHistoriesLastRequestTimestamp=timestamp;

            this.jobGroupHistoriesLoading=true;
            this.jobGroupHistoriesPage=pageNumber
            JobGroupHistoryRepository.getTable(pageNumber, this.jobGroupHistoriesFilters).then((response) => {
                if(this.jobGroupHistoriesLastRequestTimestamp!==timestamp) return; // Son atılan istek bu değil demek.

                var r=response.data;

                this.jobGroupHistories=r.results;
                this.jobGroupHistoriesTotal=r.count;
                this.jobGroupHistoriesPage=pageNumber


                for(var i in this.jobGroupHistories){
                    if (this.jobGroupHistories[i].start_time!==null && this.jobGroupHistories[i].start_time!==undefined)
                        this.jobGroupHistories[i].start_time=this.formatDefaultDate(this.timestampToDatetime(this.jobGroupHistories[i].start_time));
                    
                    if (this.jobGroupHistories[i].end_time!==null && this.jobGroupHistories[i].end_time!==undefined)
                        this.jobGroupHistories[i].end_time=this.formatDefaultDate(this.timestampToDatetime(this.jobGroupHistories[i].end_time));
                }

                this.jobGroupHistoriesLoading=false;
            })
        },
        jobGroupHistoryPageChanged(pageNumber){
            this.getJobGroupHistories(pageNumber);
        },
        setJobHistoryReportId(jobHistoryId,reportId){
            JobHistoryRepository.setReportId(jobHistoryId,reportId).then((response) => {
                this.setLocalVariableReportId([jobHistoryId],reportId);
            })
        },
        setLocalVariableReportId(jobHistoryIds, reportId){
            for(var i in jobHistoryIds){
                var jobHistoryId=jobHistoryIds[i];
                if(reportId===null){
                    delete this.importedLogs[jobHistoryId]
                }
                for(var i in this.jobHistories){
                    if(this.jobHistories[i].id===jobHistoryId){
                        this.jobHistories[i].report_id=reportId;
                        if(reportId!==null){
                            this.importedLogs[this.jobHistories[i].id]=this.jobHistories[i].job.name;
                        }
                        break;
                    }
                }
            }
            this.$forceUpdate();
        },
        setLocalVariableReportIdFromResponse(jobHistoryIds,reportId){
            for(var i in jobHistoryIds){
                var jl=jobHistoryIds[i];
                if(reportId!==null)
                    this.importedLogs[jl.id]=jl.name;
                else
                    delete this.importedLogs[jl.id]
            }
            this.$forceUpdate();
        },
        setJobGroupHistoryReportId(jobGroupHistoryId,reportId){
            JobGroupHistoryRepository.setReportId(jobGroupHistoryId,reportId).then((response) => {
                var jobHistoryIds=response.data.job_log_ids;
                reportId=reportId==0 ? null : reportId;
                this.setLocalVariableReportIdFromResponse(jobHistoryIds,reportId);
                // this.$forceUpdate();
            })
        },
        runReportOperation(operationId,operationKwargs){
            var reportName=`${this.report.search_id}`;
            if(Object.keys(operationKwargs).includes('prev_search_id')){
                if(this.previousSearchId===null || this.previousSearchId===""){
                    this.$notify({
                        message: 'Previous search ID cannot be null for this action.',
                        type: 'warning',
                        size: 'lg',
                        timeout: 5000,
                        showClose: true,
                    })
                    return
                }
                reportName+=` - ${this.previousSearchId}`;
            }
            
            operationKwargs.report_id=this.report.id;
            var payload={
                operation_id:operationId,
                report_id:this.report.id,
                report_name:reportName,
                operation_kwargs:operationKwargs,
            }

            LocationReportRepository.runReportOperation(payload).then((response) => {
                this.$notify({
                    message: `"${this.locationReportOperationMethodEnums[payload.operation_id]}" operation started for report: ${this.report.search_id} - ${this.report.name}`,
                    type: 'success',
                    size: 'lg',
                    timeout: 5000,
                    showClose: true
                });
                this.$refs.report_detail_page_process_view.addReportProcess(response.data);
            })
        },
        reset() {
            // reset form to initial state
            this.currentStatus = STATUS_INITIAL;
            this.uploadedFiles = [];
            this.uploadError = null;
            this.fileCount=0;
        },
        save(formData) {
            // upload data to the server
            this.currentStatus = STATUS_SAVING;

            LocationReportRepository.manualImport(formData,this.report.id)
            .then((response) => {
                this.currentStatus = STATUS_SUCCESS;
                
                // Burada job history güncelleniyor ve importedLogs ataması farklı şekilde yapılıyor.
                // Ekstra istek atmamak için yapıldı.
                // TODO: Burası çok karıştı bi ara düzenle
                var addedJobLogs=response.data.job_log_ids;
                this.getJobHistories(this.jobHistoriesPage);
                this.setLocalVariableReportIdFromResponse(addedJobLogs,this.report.id)
            })
            .catch(err => {
                this.uploadError = err.response.data;
                this.currentStatus = STATUS_FAILED;
            });
        },
        filesChange(fieldName, fileList) {
            // handle file changes
            const formData = new FormData();
            
            if (!fileList.length) return;
            this.fileCount=fileList.length;

            // append the files to FormData
            Array
            .from(Array(fileList.length).keys())
            .map(x => {
                formData.append(fieldName, fileList[x], fileList[x].name);
            });

            // save it
            this.save(formData);
        }
    },
    mounted(){
        this.reset();
    }
}
</script>

<style lang="scss">


.table-show-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap:10px;
    margin-top:10px;
    align-items: center;
    border-top: 1px solid;
    padding-top: 1rem;
    margin-bottom: .5rem;
    border-color: rgba(0, 0, 0, 0.05);
}

.table-show-header:first-child {
    border-top: 0; 
}


.dropbox {
    outline: 2px dashed grey; /* the dash box */
    outline-offset: -10px;
    background: lightcyan;
    color: dimgray;
    padding: 10px 10px;
    min-height: 200px; /* minimum height */
    position: relative;
    cursor: pointer;
  }
  
  .input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
  }
  
  .dropbox:hover {
    background: lightblue; /* when mouse over to the drop zone, change color */
  }
  
  .dropbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 50px 0;
  }

  .goto-joblog :hover{
      cursor: pointer !important;
  }
</style>